"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createWorkflowClient = void 0;
const novu_base_client_1 = require("./novu-base-client");
const createWorkflowClient = (baseUrl, headers = {}) => {
    const baseClient = (0, novu_base_client_1.createNovuBaseClient)(baseUrl, headers);
    const createWorkflow = async (createWorkflowDto) => {
        return await baseClient.safePost('/v2/workflows', createWorkflowDto);
    };
    const updateWorkflow = async (workflowId, updateWorkflowDto) => {
        return await baseClient.safePut(`/v2/workflows/${workflowId}`, updateWorkflowDto);
    };
    const syncWorkflow = async (workflowId, syncWorkflowDto) => {
        return await baseClient.safePut(`/v2/workflows/${workflowId}/sync`, syncWorkflowDto);
    };
    const getWorkflow = async (workflowId) => {
        return await baseClient.safeGet(`/v2/workflows/${workflowId}`);
    };
    const getWorkflowStepData = async (workflowId, stepId) => {
        return await baseClient.safeGet(`/v2/workflows/${workflowId}/steps/${stepId}`);
    };
    const patchWorkflowStepData = async (workflowId, stepId, patchStepDataDto) => {
        return await baseClient.safePatch(`/v2/workflows/${workflowId}/steps/${stepId}`, patchStepDataDto);
    };
    const patchWorkflow = async (workflowId, patchWorkflowDto) => {
        return await baseClient.safePatch(`/v2/workflows/${workflowId}`, patchWorkflowDto);
    };
    const deleteWorkflow = async (workflowId) => {
        return await baseClient.safeDelete(`/v2/workflows/${workflowId}`);
    };
    const searchWorkflows = async (queryParams) => {
        const query = new URLSearchParams();
        query.append('offset', queryParams.offset?.toString() || '0');
        query.append('limit', queryParams.limit?.toString() || '50');
        if (queryParams.orderDirection) {
            query.append('orderDirection', queryParams.orderDirection);
        }
        if (queryParams.orderBy) {
            query.append('orderBy', queryParams.orderBy);
        }
        if (queryParams.query) {
            query.append('query', queryParams.query);
        }
        return await baseClient.safeGet(`/v2/workflows?${query.toString()}`);
    };
    /**
     * @deprecated This function is deprecated and will be removed in future versions.
     * Use `searchWorkflows` instead to retrieve workflows with updated parameters and functionality.
     *
     * @param {GetListQueryParams} queryParams - The parameters for querying workflows.
     * @returns {Promise<NovuRestResult<ListWorkflowResponse, HttpError>>} - A promise that resolves to the result of the workflow retrieval.
     */
    const searchWorkflowsV1 = async (queryParams) => {
        const query = new URLSearchParams();
        query.append('defaultLimit', '10');
        query.append('maxLimit', '50');
        if (queryParams) {
            query.append('query', queryParams);
        }
        return await baseClient.safeGet(`/v1/workflows?${query.toString()}`);
    };
    /**
     * @deprecated This function is deprecated and will be removed in future versions.
     * Use `searchWorkflows` instead to retrieve workflows with updated parameters and functionality.
     *
     * @returns {Promise<NovuRestResult<ListWorkflowResponse, HttpError>>} - A promise that resolves to the result of the workflow retrieval.
     * @param templateBody
     */
    const createWorkflowsV1 = async (templateBody) => {
        return await baseClient.safePost(`/v1/workflows`, templateBody);
    };
    const generatePreview = async (workflowId, stepDatabaseId, generatePreviewDto) => {
        return await baseClient.safePost(`/v2/workflows/${workflowId}/step/${stepDatabaseId}/preview`, generatePreviewDto);
    };
    const getWorkflowTestData = async (workflowId) => {
        return await baseClient.safeGet(`/v2/workflows/${workflowId}/test-data`);
    };
    return {
        generatePreview,
        createWorkflow,
        updateWorkflow,
        syncWorkflow,
        getWorkflow,
        deleteWorkflow,
        searchWorkflows,
        getWorkflowTestData,
        getWorkflowStepData,
        patchWorkflowStepData,
        patchWorkflow,
        searchWorkflowsV1,
        createWorkflowsV1,
    };
};
exports.createWorkflowClient = createWorkflowClient;
//# sourceMappingURL=workflows-client.js.map